import CenterContentRedux from './center_content_redux';

export default CenterContentRedux;
